export enum ChannelClient {
    Amazon = 'amazon',
    Facebook = 'facebook',
    Google = 'google',
    GoogleUCP = 'google_ucp',
    GoogleProductType = 'google_product_type',
    MicrosoftAds = 'microsoft_ads_us',
    Pinterest = 'pinterest',
    Target = 'target',
    TikTok = 'tiktok',
    TikTokAds = 'tiktok_ads',
    TikTokExpansion = 'tiktok-L7'
}
